import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { Log, SmsLog } from '../../../entities/log.model';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { IMyDateRangeModel, IMyDrpOptions } from 'mydaterangepicker';

@Component({
  selector: 'app-sms-logs',
  templateUrl: './sms-logs.component.html',
  styles: []
})
export class SmsLogsComponent implements OnInit {

  @ViewChild('smsLogsTable') smsLogsTable: DatatableComponent;
  @ViewChild('smsLogModal') private smsLogModal;
  private modalRef: any = null;

  loadingIndicator: boolean;
  smsLogs: SmsLog[];
  allSmsLogs: SmsLog[];
  tempSmsLogs = [];
  searchInput = '';
  searchInputMerchantNumber = '';

  httpStatusFilter: {
    label: string,
    options: {
      value: string,
      label: string,
    }[],
    selected: {
      value: string,
      label: string,
    }
  };

  selectedSmsLog: SmsLog;

  dateRangeOptions: IMyDrpOptions = {
    dayLabels: {su: 'So', mo: 'Mon', tu: 'Di', we: 'Mi', th: 'Do', fr: 'Fr', sa: 'Sa'},
    monthLabels: { 1: 'Jan', 2: 'Feb', 3: 'Mrz', 4: 'Apr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Okt',
      11: 'Nov', 12: 'Dez' },
    dateFormat: 'dd.mm.yyyy',
    yearSelector: false,
    monthSelector: false,
    selectBeginDateTxt: 'Startdatum auswählen',
    selectEndDateTxt: 'Enddatum auswählen',
    showClearBtn: true,
    showApplyBtn: true,
    openSelectorOnInputClick: true,
    height: '26px',
    width: '239px'
  };

  dateRangeModel: any = {
    beginDate: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date(new Date().setDate(new Date().getDate() - 7)).getDate()
    },
    endDate: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate()
    }
  };

  constructor(private apiService: ApiService,
              private modalService: NgbModal) {
    this.loadingIndicator = true;
  }

  ngOnInit(): void {
    this.getLogs();
    this.httpStatusFilter = {
      label: 'Status',
      options: [
        {
          value: 'all',
          label: 'Alle'
        }
      ],
      selected: {
        value: 'all',
        label: 'Alle'
      }
    };
  }

  getLogs() {
    this.apiService.find<Log>(Log, 'logs-by-source/de_marktgilde_marketmanager_service_SmsService')
      .subscribe(logs => {
        this.loadingIndicator = false;
        this.smsLogs = logs.map<SmsLog>(log => new SmsLog(log));
        this.allSmsLogs = logs.map<SmsLog>(log => new SmsLog(log));
        this.tempSmsLogs = [...this.smsLogs];

        [...Array.from(new Set(this.smsLogs.map(smsLog => smsLog.httpResponseBody.responseMessage)))]
          .sort()
          .forEach(responseMessage => {
            if (responseMessage && responseMessage !== '') {
              this.httpStatusFilter.options.push({
                value: responseMessage,
                label: responseMessage
              });
            }
          });
        const smallestCreated = new Date(Math.min(...this.smsLogs.map(smsLog => new Date(smsLog.created).getTime())));
        const greatestCreated = new Date(Math.max(...this.smsLogs.map(smsLog => new Date(smsLog.created).getTime())));
        this.dateRangeModel = {
          beginDate: {
            year: smallestCreated.getFullYear(),
            month: smallestCreated.getMonth() + 1,
            day: smallestCreated.getDate()
          },
          endDate: {
            year: greatestCreated.getFullYear(),
            month: greatestCreated.getMonth() + 1,
            day: greatestCreated.getDate()
          }
        };
      }, err => {
        this.loadingIndicator = false;
        this.smsLogs = [];
      });
  }

  changeFilter(filter, filterOption) {
    filter.selected = filterOption;
    this.filterSmsLogs();
  }

  filterSmsLogs() {
    this.searchInput = '';
    this.searchInputMerchantNumber = '';

    this.smsLogs = this.allSmsLogs
      .filter((smsLog, index) => {
        const smsLogDate = new Date(smsLog.created);
        const beginDate = new Date(this.dateRangeModel.beginDate.year, this.dateRangeModel.beginDate.month - 1,
          this.dateRangeModel.beginDate.day);
        const endDate = new Date(this.dateRangeModel.endDate.year, this.dateRangeModel.endDate.month - 1,
          this.dateRangeModel.endDate.day, 23, 59, 59, 999);
        return(
          (this.httpStatusFilter.selected.value !== 'all') ?
            smsLog.httpResponseBody.responseMessage === this.httpStatusFilter.selected.value : true) &&
          smsLogDate >= beginDate && smsLogDate <= endDate;
      });

    this.tempSmsLogs = [...this.smsLogs];
    this.smsLogsTable.offset = 0;
  }

  onDateRangeChanged(event: IMyDateRangeModel) {
    console.log('event', event);
    this.dateRangeModel = {
      beginDate: {
        year: event.beginDate.year,
        month: event.beginDate.month,
        day: event.beginDate.day
      },
      endDate: {
        year: event.endDate.year,
        month: event.endDate.month,
        day: event.endDate.day
      }
    };
    this.filterSmsLogs();
  }

  updateSearch(event, field = null) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.tempSmsLogs.filter((smsLog: SmsLog) => {
      if (field) {
        return ((smsLog.merchantNumber) ? smsLog.merchantNumber.toLowerCase().indexOf(val) !== -1 : !val);
      } else {
        return ((smsLog.message) ? smsLog.message.toLowerCase().indexOf(val) !== -1 : false) ||
          ((smsLog.recipient) ? smsLog.recipient.toLowerCase().indexOf(val) !== -1 : false) ||
          ((smsLog.httpResponseBody && smsLog.httpResponseBody.msgid) ?
            smsLog.httpResponseBody.msgid.indexOf(val) !== -1 : false) ||
          !val;
      }
    });

    // update the rows
    this.smsLogs = temp;
    // Whenever the filter changes, always go back to the first page
    this.smsLogsTable.offset = 0;
  }

  onActivate(event: any) {
    if (event.type === 'click') {
      event.cellElement.blur();
    }
  }

  onSelect(event: any) {
    this.selectedSmsLog = event.selected[0];
    this.openModal(this.smsLogModal, {size: 'sm', windowClass: 'l'});
  }

  openModal(modal: any, options: NgbModalOptions) {
    this.modalRef = this.modalService.open(modal, options);
  }

}




// WEBPACK FOOTER //
// ./src/app/logs/components/sms-logs/sms-logs.component.ts